import React from 'react'
import circle_exclamation from '../../../assets/images/icons/circle_exclamation.svg'
import AppWrapper from '../../layout/AppWrapper'

export default function FallbackErrorPage({resetErrorBoundary, ...otherProps}) {
  console.log(otherProps)
  return (
    <AppWrapper>
      <div style={{minHeight: '70vh'}} className='py-4 d-flex flex-column align-items-center justify-content-center'>
        <img height={50} src={circle_exclamation} alt='circled exclamation icon'/>
        <h3 className='fallback-header mt-2'>Oops! Something went wrong.</h3>
        <p className='fallback-text'>Please refresh page to load data or try again later</p>
      </div>
    </AppWrapper>
  )
}
